// treeTotal.js — the category tree's "objects" number on the book scopes: ONE rule (F-089, 2026-09-07).
//
// A LANDED answer is the number, zero included. Only while the answer for the current question has not
// landed may the tree show the last cached total for the same question, and never a different question's.
// The bug this replaces: `listingTotal > 0 ? listingTotal : cachedTotal` read a landed 0 as "not arrived"
// and drew the cached UNFILTERED pool total (459) over an empty filtered archive, with no headline.
// 2026-10-22: `filtered` — the cached total (tc:) is keyed without filters, i.e. the UNFILTERED answer;
// while a filtered search is in flight it is another question's number, so nothing stands in.
export function treeTotalFor({ landed, total, cachedTotal, filtered = false }) {
  if (landed) return Number.isFinite(total) ? total : null
  if (filtered) return null
  return cachedTotal > 0 ? cachedTotal : null
}
